<template>
  <div data-testid="ImportModule">
    <router-view v-if="moduleIsReady" />
    <div v-else>Loading Imports...</div>
  </div>
</template>

<script lang="ts">
import { Vue, Prop } from 'vue-property-decorator';

export default class ImportModule extends Vue {
  created() {
    this.bootstrap();
  }

  get moduleIsReady() {
    return true;
  }

  bootstrap() {
    //
  }
}
</script>
